<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h2>Edit Zone</h2>
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <form>
          <div class="form-group">
            <label for="txtName">Name</label>
            <input type="text" class="form-control" id="txtName" v-model="zone.name">
          </div>
          <div class="form-group">
            <label for="inpColor">Color</label>
            <color-picker id="inpColor" v-model="zone.color"></color-picker>
          </div>
          <div class="form-group" v-if="zone.zone_type_id === 3">
            <label for="txtIp">IP</label>
            <input type="text" class="form-control" id="txtIp" v-model="zone.ip">
          </div>
          <div class="form-group" v-if="zone.zone_type_id === 3">
            <label for="txtPort">Port</label>
            <input type="text" class="form-control" id="txtPort" v-model="zone.port">
          </div>
          <div class="form-group" v-if="zone.zone_type_id !== 4">
            <label for="txtExtension">Extension</label>
            <input type="text" class="form-control" id="txtExtension" v-model="zone.extension">
            <small class="form-text text-muted">Must keep leading 6 and follow with 3 numbers. Example: 6061</small>
          </div>
          <div class="form-group" v-if="zone.zone_type_id !== 4">
            <label for="txtHangupSeconds">Paging calls will auto hangup after x seconds</label>
            <input type="number" class="form-control" id="txtHangupSeconds" min="0" v-model="zone.hangup_seconds">
            <small class="form-text text-muted">0 for no hangup</small>
          </div>
          <button type="button" class="btn btn-hub-primary" @click="submit()" >Submit</button>
          <router-link :to="{ name: 'ZoneManager' }" class="btn btn-secondary">Cancel</router-link>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Sketch } from 'vue-color'

export default {
  props: [
    'zone_id'
  ],
  computed: {
    ...mapGetters({
      zone: 'singleZone'
    })
  },
  components: {
    'color-picker': Sketch
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getZone', this.zone_id)
  },
  methods: {
    submit () {
      this.$store.dispatch('addEditZone', { zone: this.zone, next: 'ZoneManager' })
    }
  }
}
</script>

<style scoped>

</style>
